/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="filters.module.ts" />

module Meevo.Components.Filters {

    export function meevoFirstLetterFilter(): angular.IFilterService {
        const filter = (input: any) => {

            if (!input) {
                return "";
            }
            return (input.firstName?input.firstName.charAt(0).toUpperCase():"") + (input.lastName?input.lastName.charAt(0).toUpperCase():"");
        };
        return filter;
    }


    angular.module("meevo.components.filters")
      .filter("meevoFirstLetterFilter", meevoFirstLetterFilter);




    /*
    * Creates initials from a user name or an employee first and last name
    */
    export function meevoEmployeeUserInitialDisplay() : angular.IFilterService {
      const display = (input: any) => {
        if (!input) {
          return "";
        }
        return !input.isEmployee
          ? input.displayName.charAt(0).toUpperCase()
          : input.firstName.charAt(0).toUpperCase() + input.lastName.charAt(0).toUpperCase();
      }
      return display;
    };

    angular.module("meevo.components.filters")
      .filter("meevoEmployeeUserInitialDisplay", meevoEmployeeUserInitialDisplay);
}
